/**
 * <Comente>
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.SecondsRange = (function () {

    function SecondsRange () {

        Monet.UI.Fields.Seconds.apply(this, arguments);

        this.value = { ini: '', fin: '' };

        this.createBaseStructure();

        this.createElement = function () {

            this.inputIni = document.createElement('input');
            this.inputFin = document.createElement('input');

            this.inputIni.type = 'text';
            this.inputIni.className = 'MonetUIFieldSeconds';

            this.inputFin.type = 'text';
            this.inputFin.className = 'MonetUIFieldSeconds';

            if (this.maxSize) {
                this.inputIni.maxLength = this.maxSize;
                this.inputFin.maxLength = this.maxSize;
            }

            this.rootEl.appendChild(this.inputIni);
            this.rootEl.appendChild(this.inputFin);

        };

        this.getValue = function () {

            return {
                ini: new Monet.Format.SECONDS(this.inputIni.value).convertHourToSeconds().getValue(),
                fin: new Monet.Format.SECONDS(this.inputFin.value).convertHourToSeconds().getValue()
            };
        };

        this.isEmpty = function () {
            return !(this.getValue() && this.getValue().ini && this.getValue().fin);
        };

        this.setValue = function (values) {
            this.value = values || this.value;
            this.setInputValue();
        };

        this.setInputValue = function () {

            if (this.inputIni && this.inputFin) {

                var iniFormatted = this.value.ini;
                var finFormatted = this.value.fin;

                if (typeof this.value.ini === "number") {
                    iniFormatted = new Monet.Format.SECONDS(iniFormatted).convertSecondsToHourMinutesSeconds().getValue();
                }

                if (typeof this.value.fin === "number") {
                    finFormatted = new Monet.Format.SECONDS(finFormatted).convertSecondsToHourMinutesSeconds().getValue();
                }

                this.inputIni.value = iniFormatted;
                this.inputFin.value = finFormatted;
            }

        };

        this.initializeSpecialBehavior = function () {

            const title = Monet.I18n.getResourcesByKey("Greenmile.TimePicker.Title");

            const options = {
                hourGrid: 4,
                minuteGrid: 10,
                secondGrid: 10,
                timeFormat: 'HH:mm:ss',
                timeOnlyTitle: title,
                beforeShow: () => {
                    $('main').append($('#ui-datepicker-div'));
                }
            };

            $(this.inputFin).timepicker(options);
            
            options.beforeShow = options.onSelect = (input, dpInst) => {
                $('main').append($('#ui-datepicker-div'));
                this.focusNext('button.ui-datepicker-close[data-handler="hide"]', dpInst);
            };

            $(this.inputIni).timepicker(options);

        };

        this.clear = function () {
            this.setValue({ ini: '', fin: '' });
        };

        this.render = function () {

            this.createElement();
            this.initializeSpecialBehavior();
            return this.rootEl;

        };

    }

    return SecondsRange;

}());